export default __webpack_public_path__ + "static/media/down_icons.e7359dce.svg";